import { EtapaSelect } from "../etapa/etapa-select-model";
import { IdNome } from "../id-nome.model";

export class SessaoFiltro {
  atividade?: IdNome;
  nomeContato?: string
  dataAberturaInicio?: Date;
  dataAberturaFim?: Date;
  fluxos: EtapaSelect[] = [];
  operadores: IdNome[] = [];
}
